import { FingerPrintIcon, UsersIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import Tabs from "src/components/Shared/Tabs/Tabs";
import { H1 } from "src/components/Shared/Text/Headers";
import UsersList from "src/components/Users/List/UsersList";
import UserSettings from "src/components/Users/UserSettings";

const Admins = () => {
  const [subTitle, setSubTitle] = useState("");

  const tabs = [
    { name: "Admin List", icon: UsersIcon, component: <UsersList setSubTitle={setSubTitle} /> },
    { name: "Privacy & Security", icon: FingerPrintIcon, component: <UserSettings /> },
  ];

  return (
    <>
      <H1>
        Admin List
        <div className="text-base font-normal text-gray-400">{subTitle}</div>
      </H1>

      <Tabs tabs={tabs} />
    </>
  );
};

export default Admins;
